// types
import { createSlice } from "@reduxjs/toolkit";

interface DashboardReportsProps {
  abandondedCartsCount: number;
  totalSales: number;
  labels: string[];
  ordersData: number[];
  salesData: number[];
  loadingReport: boolean;
}
// initial state
const initialState: DashboardReportsProps = {
  abandondedCartsCount: 0,
  totalSales: 0,
  labels: [],
  salesData: [],
  ordersData: [],
  loadingReport: true,
};

// ==============================|| SLICE - MENU ||============================== //

const dashboardAndReports = createSlice({
  name: "dashboardAndReports",
  initialState,
  reducers: {
    setAbandondedCartsCount(state, action) {
      state.abandondedCartsCount = action.payload;
    },
    setTotalSales(state, action) {
      state.totalSales = action.payload;
    },
    setGroupByDateReport(state, action) {
      const { labels, ordersData, salesData } = action.payload;

      state.labels = labels;
      state.salesData = salesData;
      state.ordersData = ordersData;
    },
    statsLoader(state, action) {
      state.loadingReport = action.payload;
    },
  },
});

export default dashboardAndReports.reducer;

export const {
  setAbandondedCartsCount,
  setTotalSales,
  setGroupByDateReport,
  statsLoader,
} = dashboardAndReports.actions;
